import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import { getSession } from 'core_main/api/sessions';
import { createGetConversationCallbackResponse } from './helpers';
import { GetConversationParameters } from './types';

export const getConversation = (
  parameters: GetConversationParameters,
  cb?: PublicCallback,
) => {
  const sessionId = parameters?.conversationId;
  return getSession(sessionId)
    .then((response) => {
      const callbackResponse = createGetConversationCallbackResponse(
        response.data,
      );

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }

      return response;
    })
    .catch((error) => {
      handleError(error, { message: `Failed to get conversation:` });
      if (typeof cb === 'function') cb(null, error);
    });
};
